// Everyone who works in the acting company, and how the board pages use them.
//
// The roster endpoint returns members (by membership, see
// src/auth/members.ts) with a status, active-only unless inactive people were
// asked for. Splitting the three uses here keeps the rule in one place: names
// resolve for anyone, filters may offer anyone, and only active people can be
// picked as an assignee — the server refuses the rest with a 400.

export type RosterPerson = { id: string; name: string; status: string }

export const isAssignable = (person: RosterPerson) => person.status === "active"

export function rosterFrom(people: RosterPerson[]) {
  return {
    // Names on cards, including disabled people who still hold work.
    roster: new Map(people.map((person) => [person.id, person.name])),
    // Filters: anyone who may hold tasks.
    people,
    // Pickers: the people the server will accept.
    assignable: people.filter(isAssignable),
  }
}
